import React from "react";
import { LoginRegisterTemplate } from "../../Templates/LoginRegisterTemplate";

export const LoginRegister = () => {
  return <LoginRegisterTemplate />;
};
